import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  addDoc,
  collection,
  Timestamp,
  getDocs,
  where,
  query,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firbase/firebase";

export const fetchBlogs = createAsyncThunk(
  "blog/fetchBlogs",
  async (categoryId = null) => {
    try {
      let q = query(collection(db, "blogs"));
      console.log("q", q);

      if (categoryId) {
        q = query(
          collection(db, "blogs"),
          where("categoryId", "==", categoryId)
        );
      }
      const querySnapshot = await getDocs(q);

      return querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          id: doc.id,
          ...doc.data(),
          postedDate: data.postedDate
            ? data.postedDate.toDate().toISOString()
            : null,
        };
      });
    } catch (error) {
      throw new Error(error.message);
    }
  }
);



export const addBlog = createAsyncThunk(
  "blog/addBlog",
  async (blogData, { dispatch }) => {
    try {
      const createdAt = new Date();
      const cleanedData = Object.fromEntries(
        Object.entries(blogData).filter(([_, v]) => v !== undefined)
      );

      await addDoc(collection(db, "blogs"), {
        ...cleanedData,
        postedDate: Timestamp.now(),
      });

      dispatch(fetchBlogs()); // optional
      return cleanedData;
    } catch (error) {
      console.error("Error adding blog:", error.message);
      throw error; // no need to wrap again
    }
  }
);

export const deleteBlog = createAsyncThunk(
  "blog/deleteBlog",
  async ({ id, createdAt }, { dispatch, rejectWithValue }) => {
    try {
      const blogRef = doc(db, "blogs", id);
      await deleteDoc(blogRef);

      // optional: re-fetch all blogs
      dispatch(fetchBlogs());

      return id; // return deleted blog id
    } catch (error) {
      console.error("Error deleting blog:", error.message);
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  blogs: [],
  loading: false,
  title: "",
  subtitle: "",
  content: "",
  author: "",
  designation: "",
  categoryId: "",
  image: null,
  editblog: null,
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    setBlogs: (state, action) => {
      state.blogs = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    setSubTitle: (state, action) => {
      state.subtitle = action.payload;
    },
    setContent: (state, action) => {
      state.content = action.payload;
    },
    setAuthor: (state, action) => {
      state.author = action.payload;
    },
    setDesignation: (state, action) => {
      state.designation = action.payload;
    },
    setCategory: (state, action) => {
      state.categoryId = action.payload;
    },

    setImage: (state, action) => {
      state.image = action.payload;
    },
    setImageLoading: (state, action) => {
      state.loading = action.payload;
    },

    resetBlogs: (state) => {
      state.title = "";
      state.subtitle = "";
      state.content = "";
      state.author = "";
      state.designation = "";
      state.categoryId = "";
      state.image = null;
      localStorage.removeItem("blogImage");
    },

    setEditingBlog: (state, action) => {
      state.editingBlog = action.payload;
      if (action.payload) {
        const b = action.payload;
        state.title = b.title || "";
        state.subtitle = b.subtitle || "";
        state.content = b.content || "";
        state.author = b.author || "";
        state.designation = b.designation || "";
        state.image = b.image || null;
        state.categoryId = b.categoryId || "";
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = action.payload;
      })
      .addCase(fetchBlogs.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addBlog.pending, (state) => {
        state.loading = true;
      })
      .addCase(addBlog.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addBlog.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateBlog.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateBlog.fulfilled, (state, action) => {
        state.loading = false;
        state.editingBlog = null;
        const updated = action.payload;
        const index = state.blogs.findIndex((b) => b.id === updated.id);
        if (index !== -1) {
          state.blogs[index] = { ...state.blogs[index], ...updated };
        }
      })
      .addCase(updateBlog.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deleteBlog.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteBlog.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = state.blogs.filter((blog) => blog.id !== action.payload);
      })
      .addCase(deleteBlog.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const updateBlog = createAsyncThunk(
  "blog/updateBlog",
  async ({ id, updatedData }, { dispatch }) => {
    try {
      const cleanedData = Object.fromEntries(
        Object.entries(updatedData).filter(([_, v]) => v !== undefined)
      );

      const blogRef = doc(db, "blogs", id);
      await updateDoc(blogRef, cleanedData);

      dispatch(fetchBlogs()); // refresh data
      return { id, ...cleanedData };
    } catch (error) {
      console.error("Error updating blog:", error.message);
      throw error;
    }
  }
);

export const {
  setBlogs,
  setLoading,
  setAuthor,
  setCategory,
  setContent,
  setTitle,
  setDesignation,
  setSubTitle,
  setImage,
  resetBlogs,
  setImageLoading,
  setEditingBlog,
} = blogSlice.actions;
export default blogSlice.reducer;
